<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="正式订单" style="width: 200px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="产品代码" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword3" placeholder="产品名称" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword4" placeholder="工序" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <div style="margin-top: 10px;">
          <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
            :clearable="false" :editable="false"></el-date-picker>
        </div>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="姓名" min-width="100" prop="xingming"></el-table-column>
          <el-table-column align="center" label="备料订单" min-width="100" prop="beiliaodingdan"></el-table-column>
          <el-table-column align="center" label="正式订单" min-width="100" prop="zhengshidingdan"></el-table-column>
          <el-table-column align="center" label="产品代码" min-width="100" prop="chanpindaima"></el-table-column>
          <el-table-column align="center" label="产品名称" min-width="100" prop="chanpinmingcheng"></el-table-column>
          <el-table-column align="center" label="单位" min-width="100" prop="danwei"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="部件名称" min-width="150" prop="bujianmingcheng"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="日定额标准产量" min-width="100" prop="ridingebzcl"></el-table-column>
          <el-table-column align="center" label="日定额标准工资额" min-width="100" prop="ridingebzgze"></el-table-column>
          <el-table-column align="center" label="标准单件单价" min-width="100" prop="biaozhundjdj"></el-table-column>
          <el-table-column align="center" label="日实际完成数量" min-width="100" prop="rishijiwcsl"></el-table-column>
          <el-table-column align="center" label="日实际完成工资额" min-width="100" prop="rishijiwcgze"></el-table-column>
          <el-table-column align="center" label="计件数量" min-width="100" prop="jijianshuliang"></el-table-column>
          <el-table-column align="center" label="计件单价" min-width="100" prop="jijiandanjia"></el-table-column>
          <el-table-column align="center" label="异常计时内容" min-width="100" prop="yichangjsnr"></el-table-column>
          <el-table-column align="center" label="异常计时工资额" min-width="100" prop="yichangjsgze"></el-table-column>
          <el-table-column align="center" label="异常计件内容" min-width="100" prop="yichangjjnr"></el-table-column>
          <el-table-column align="center" label="异常计件工资额" min-width="100" prop="yichangjjgze"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="姓名" prop="xingming">
          <div style="display: flex;">
            <el-input v-model="editForm.xingming" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.xingming" filterable placeholder="请选择"
              @change="xingmingChange" style="width: 400px;">
              <el-option v-for="(item,index) in memberSelectList"
                :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="备料订单" prop="beiliaodingdan">
          <el-input v-model="editForm.beiliaodingdan"></el-input>
        </el-form-item>
        <el-form-item label="正式订单" prop="zhengshidingdan">
          <el-select filterable v-model="orderValue"
            placeholder="请选择" @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.zhengshidingdan+'_'+item.chanpindaima+'_'+item.chanpinmingcheng+'_'+item.gongxu" 
              :label="item.zhengshidingdan+'_'+item.chanpindaima+'_'+item.chanpinmingcheng+'_'+item.gongxu" 
              :value="item.zhengshidingdan+'_'+item.chanpindaima+'_'+item.chanpinmingcheng+'_'+item.gongxu">
            </el-option>
          </el-select>
          <el-input v-model="editForm.zhengshidingdan" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="产品代码" prop="chanpindaima">
          <el-input v-model="editForm.chanpindaima"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="chanpinmingcheng">
          <el-input v-model="editForm.chanpinmingcheng"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="danwei">
          <el-input v-model="editForm.danwei"></el-input>
        </el-form-item>
        <el-form-item label="订单数量" prop="dingdanshuliang">
          <el-input-number v-model="editForm.dingdanshuliang" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="部件名称" prop="bujianmingcheng">
          <el-input v-model="editForm.bujianmingcheng"></el-input>
        </el-form-item>
        <el-form-item label="工序" prop="gongxu">
          <el-input v-model="editForm.gongxu"></el-input>
        </el-form-item>
        <el-form-item label="日定额标准产量" prop="ridingebzcl">
          <el-input-number v-model="editForm.ridingebzcl" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="日定额标准工资额" prop="ridingebzgze">
          <el-input-number v-model="editForm.ridingebzgze" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="标准单件单价" prop="biaozhundjdj">
          <el-input-number v-model="editForm.biaozhundjdj" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="日实际完成数量" prop="rishijiwcsl">
          <el-input-number v-model="editForm.rishijiwcsl" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="日实际完成工资额" prop="rishijiwcgze">
          <el-input-number v-model="editForm.biaozhundjdj" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="计件数量" prop="jijianshuliang">
          <el-input-number v-model="editForm.jijianshuliang" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="计件单价" prop="jijiandanjia">
          <el-input-number v-model="editForm.jijiandanjia" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="异常计时内容" prop="yichangjsnr">
          <el-input-number v-model="editForm.yichangjsnr" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="异常计时工资额" prop="yichangjsgze">
          <el-input-number v-model="editForm.yichangjsgze" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="异常计件内容" prop="yichangjjnr">
          <el-input-number v-model="editForm.yichangjjnr" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="异常计件工资额" prop="yichangjjgze">
          <el-input-number v-model="editForm.yichangjjgze" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="成控单价" prop="chengkongdanjia">
          <el-input-number v-model="editForm.chengkongdanjia" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    xingming: "",
    beiliaodingdan: "",
    zhengshidingdan: "",
    chanpindaima: "",
    chanpinmingcheng: "",
    danwei: "",
    dingdanshuliang: 0,
    bujianmingcheng: "",
    gongxu: "",
    ridingebzcl: 0,
    ridingebzgze: 0,
    biaozhundjdj: 0,
    rishijiwcsl: 0,
    rishijiwcgze: 0,
    biaozhunchanliang: 0,
    jijianshuliang: 0,
    jijiandanjia: 0,
    yichangjsnr: 0,
    yichangjsgze: 0,
    yichangjjnr: 0,
    yichangjjgze: 0,
    chengkongdanjia: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keyword3: "",
      keyword4: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      orderValue: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
    this.getMemberSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].zhengshidingdan==arr[0]&&this.orderSelectList[i].chanpindaima==arr[1]
          &&this.orderSelectList[i].chanpinmingcheng==arr[2]&&this.orderSelectList[i].gongxu==arr[3]) {
          this.editForm.zhengshidingdan = this.orderSelectList[i].zhengshidingdan
          this.editForm.chanpindaima = this.orderSelectList[i].chanpindaima
          this.editForm.chanpinmingcheng = this.orderSelectList[i].chanpinmingcheng
          this.editForm.danwei = this.orderSelectList[i].danwei
          this.editForm.dingdanshuliang = this.orderSelectList[i].dingdanshuliang
          this.editForm.bujianmingcheng = this.orderSelectList[i].bujianmingcheng
          this.editForm.gongxu = this.orderSelectList[i].gongxu
          this.editForm.jijiandanjia = this.orderSelectList[i].jijiandanjia
          this.editForm.chengkongdanjia = this.orderSelectList[i].chengkongdanjia
        }
      }
    },
    
    xingmingChange(e) {
      for(let i in this.memberSelectList) {
        if(this.memberSelectList[i].name==e) {
          // this.editForm.gongxu = this.memberSelectList[i].gongxu
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/biantengMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.keyword3 = ""
      this.keyword4 = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.zhengshidingdan) {
        this.editForm.zhengshidingdan = form.zhengshidingdan
        this.editForm.chanpindaima = form.chanpindaima
        this.editForm.chanpinmingcheng = form.chanpinmingcheng
        this.editForm.danwei = form.danwei
        this.editForm.dingdanshuliang = form.dingdanshuliang
        this.editForm.bujianmingcheng = form.bujianmingcheng
        this.editForm.gongxu = form.gongxu
        this.editForm.jijiandanjia = form.jijiandanjia
        this.editForm.chengkongdanjia = form.chengkongdanjia
      }
      if(form.xingming) {
        this.editForm.xingming = form.xingming
      }
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/orderform/biantengInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/orderform/biantengDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/orderform/biantengSave', data).then((res) => {
            if(res.data.code==200) {
              this.$message.success(res.data.msg)
              this.editModal = false
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      if(this.keyword3) {
        data.keyword3 = this.keyword3
      }
      if(this.keyword4) {
        data.keyword4 = this.keyword4
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/orderform/biantengList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
